module.exports = {"620702001":"东街街道","620702002":"南街街道","620702003":"西街街道","620702004":"北街街道","620702005":"火车站街道","620702100":"梁家墩镇","620702101":"上秦镇","620702102":"大满镇","620702103":"沙井镇","620702104":"乌江镇","620702105":"甘浚镇","620702106":"新墩镇","620702107":"党寨镇","620702108":"碱滩镇","620702109":"三闸镇","620702110":"小满镇","620702111":"明永镇","620702112":"长安镇","620702203":"安阳乡","620702204":"花寨乡","620702205":"龙渠乡","620702207":"靖安乡","620702211":"平山湖蒙古族乡","620702400":"甘肃农垦张掖农场","620702401":"甘肃省农业科学院张掖试验场","620702402":"甘肃张掖工业园区","620702403":"张掖滨河新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620702.json
// module id = 2706
// module chunks = 0